export const environment = {
  production: true,
  tenantId: '33d8cf3c-2f14-48c0-9ad6-5d2825533673',
  clientId: '945d1537-13b3-46a5-bb39-4e1e71fdb354',
  apiEndpoint: 'https://apih.ap.be',
  apiEndpointLang: 'nl',
  apiEndpointApp: 'exapro',
  scopes: 'openid profile email https://apih.ap.be/access-api'
};
